import React, { useState } from "react";
import { List, ListItem, ListItemText, Typography, Box } from "@mui/material";
import GroupedBetDetails from "./GroupedBetDetails";

const MobileBetDetails = ({ market }) => {
  const [selectedBet, setSelectedBet] = useState(null);

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: selectedBet ? "absolute" : "relative",
          width: "100%",
          opacity: selectedBet ? 0 : 1,
          visibility: selectedBet ? "hidden" : "visible",
          transition: "opacity 0.2s ease-in-out",
        }}
      >
        <List sx={{ py: 0 }}>
          {Object.entries(market.groupedBets).map(([key, value]) => (
            <ListItem
              key={key}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                py: 1,
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedBet({ key, value });
                const element = document.getElementById(market.marketId);
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <ListItemText
                primary={key}
                primaryTypographyProps={{
                  variant: "body1",
                  fontWeight: "medium",
                }}
              />
              <Box
                sx={{
                  backgroundColor: "secondary.main",
                  borderRadius: "6px",
                  padding: "6px 12px",
                }}
              >
                <Typography variant="body1" fontWeight="bold">
                  {value.maxOdds.toFixed(2)}
                </Typography>
              </Box>
            </ListItem>
          ))}
        </List>
      </Box>

      <Box
        sx={{
          position: selectedBet ? "relative" : "absolute",
          width: "100%",
          opacity: selectedBet ? 1 : 0,
          visibility: selectedBet ? "visible" : "hidden",
          transition: "opacity 0.2s ease-in-out",
        }}
      >
        {selectedBet && (
          <GroupedBetDetails
            bet={selectedBet}
            market={market}
            onBack={() => setSelectedBet(null)}
          />
        )}
      </Box>
    </Box>
  );
};

export default MobileBetDetails;
